<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs hidden-md">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                            <router-link :to="{'name': 'CadastrarPedidos', 'query': {'t': 'agendar'}}" class="button block-mobile big margin-bottom-10 float-right hidden-lg hidden-md" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                <i class="material-icons">event_available</i>
                                Agendar
                            </router-link>                            
                        </h3>
                    </div>
                     
                    <div class="row" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'prestador' || $root.user.tipo == 'gerencial'">

                        <!-- Dashboard Box -->
                        <div class="col-lg-12 margin-bottom-10 hidden-xl" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                            <router-link :to="{'name': 'CadastrarPedidos', 'query': {'t': 'agendar'}}" class="button block-mobile big margin-bottom-10">
                                <i class="material-icons">event_available</i>
                                Agendar
                            </router-link>                            
                        </div>
                        <div class="col-xs-12 col-xl-5 col-lg-6 col-md-6">
                            <div class="tabs tabs-default margin-bottom-15">
                                <div class="tabs-header">
                                    <ul style="width: 100%;">
                                        <li style="width: 50%;" v-bind:class="{'active': tab == 'agendados'}">
                                            <a v-on:click="setTab('agendados')">
                                                <i class="material-icons">event</i>
                                                Agendados
                                            </a>
                                        </li>
                                        <li style="width: 50%;" v-bind:class="{'active': tab == 'cancelados'}">
                                            <a v-on:click="setTab('cancelados')">
                                                <i class="material-icons">close</i>
                                                Cancelados
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>    
                        <div class="col-xl-12">
                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="get" novalidate="">
                                <div class="row">
                                    <div class="col-lg-8 col-xs-12 col-xl-8">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Pesquisar:</h5>
                                            <input type="text" class="with-border margin-bottom-0" placeholder="Nome, CPF, e-mail, telefone.." name="pesquisa" v-model="form.pesquisa">
                                        </div>
                                    </div>
                                    <div class="col-xl-12 clearfix"></div>
                                    <div class="col-lg-4 col-xs-6 col-xl-3 col-md-5">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>De:</h5>
                                            <input type="date" class="with-border margin-bottom-0" required="" data-placeholder="___ /____ /_____" v-model="form.dataInicio">
                                        </div>
                                    </div>        
                                    <div class="col-lg-4 col-xs-6 col-xl-3 col-md-5">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Até:</h5>
                                            <input type="date" class="with-border margin-bottom-0" required="" data-placeholder="___ /____ /_____" v-model="form.dataFinal">
                                        </div>
                                    </div>                                                                
                                    <div class="col-lg-4 col-xs-9 col-xl-4 col-md-6" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Filial:</h5>
                                            <select class="with-border margin-bottom-0" v-model="form.empresaCod" name="empresaCod">
                                                <option value="" selected>Todas</option>
                                                <option v-for="item in empresas.itens" :value="item.cod">{{item.nome}}</option>
                                            </select> 
                                        </div>
                                    </div>                                                                

                                    <div class="col-lg-1 col-xs-2">
                                        <div class="submit-field">
                                            <div class="hidden-xl hidden-lg hidden-sm clearfix" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'" style="margin-top: 30px;"></div>
                                            <div class="hidden-xs hidden-md hidden-lg clearfix" style="margin-top: 32px;"></div>
                                            <button class="button gray ">
                                                <i class="material-icons">search</i>
                                            </button>                                          
                                        </div>
                                    </div>
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form> 
                        </div>                    
                        <div class="col-xl-12" v-show="tab == 'agendados'">                        

                            <h4 class="margin-bottom-10">
                                <i class="material-icons">warning</i> 
                                <b>Aguardando confirmação</b>
                            </h4>

                            <div class="table-scroll" style="overflow-x: scroll;">

                                <table class="table table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 30px; width: 30px;">
                                            ID
                                        </th>
                                        <th style="min-width: 160px;">
                                            Piloto
                                        </th>    
<!--                                         <th style="min-width: 110px; width: 110px;">
                                            Pref. aeronave
                                        </th>   -->      
                                        <th style="min-width: 100px; width: 100px;">
                                            Combustível
                                        </th>                                              
                                        <th style="min-width: 130px; width: 130px;" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                            Filial
                                        </th>                                                                                                                                             
                                        <th style="min-width: 155px; width: 155px;">
                                            Agendado para
                                        </th>
                                        <th style="min-width: 80px; width: 80px;">
                                            Ações
                                        </th>                                                                        
                                    </thead>
                                    <tbody>   
<!--                                         <tr>
                                            <td data-label="ID">
                                                
                                                1
                                                </a>
                                            </td>
                                            <td data-label="Piloto">
                                                
                                                <u>Anderson Alves</u>
                                                </a>
                                            </td>
                                            <td data-label="Combustível">
                                                
                                                JET-A1
                                                </a>
                                            </td> 
                                            <td data-label="Litros">
                                                
                                                14
                                                </a>
                                            </td> 
                                            <td data-label="Pref. aeronave">
                                                
                                                PT-ZKW
                                                </a>
                                            </td>    
                                            <td data-label="Filial">
                                                
                                                Caçador SBCD                                                                                                         
                                                </a>
                                            </td>    
                                            <td data-label="Agendado para">
                                                
                                                10/08/2020 08:52
                                                </a>
                                            </td>
                                            <td data-label="Valor">
                                                
                                                R$ 568,67
                                                </a>
                                            </td>
                                            <td data-label="Ações">
                                                <a class="dashboard-status-button margin-bottom-5 color-green">Confirmar</a>
                                            </td>
                                        </tr> -->

                                        <tr v-show="data.pendentes.itens.length == 0 && loaded">
                                            <td colspan="9">
                                                Nenhum resultado encontrado.
                                            </td>
                                        </tr>

                                        <tr v-for="item in data.pendentes.itens">
                                            <td data-label="ID">
                                                {{item.id}}
                                            </td>
                                            <td data-label="Piloto">
                                                <u>{{item.contratante.nome}}</u>
                                                <br v-if="item.cliente">
                                                <small v-if="item.cliente"><i class="material-icons">people</i> Cliente:    <strong style="font-weight: bold !important; color: #000;">{{item.cliente.razaoSocial ? item.cliente.razaoSocial : item.cliente.nome}}</strong></small>                                                
                                                <br>
                                                <small><i class="material-icons">airplanemode_active</i> Pref. aeronave:    <strong style="font-weight: bold !important; color: #000;">{{item.auxiliar1}}</strong></small>
                                            </td>
                                            <td data-label="Combustível">
                                                {{item.catalogo.nome}}<br>
                                                <small v-show="item.quantidade && item.quantidade != 0"><i class="material-icons">local_gas_station</i>{{item.quantidade && item.quantidade != 0 ? item.quantidade + " litros" : ''}}</small>
                                            </td> 
<!--                                             <td data-label="Pref. aeronave">
                                                {{item.auxiliar1}}
                                            </td>     -->
                                            <td data-label="Filial" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                                {{item.empresa.nome}}
                                            </td>    
                                            <td data-label="Agendado para">
                                                {{item.data | formatDate}} às {{item.horaInicio.substr(0,item.horaInicio.length -3)}}h
                                            </td>
                                            <td data-label="Ações">
                                                <a class="dashboard-status-button margin-bottom-5 color-green click" v-on:click="confirmar(item.cod)">Confirmar</a>
                                            </td>
                                        </tr>
                                                                                                                                                                                                  
                                    </tbody>
                                </table>
                            </div>


                            <h4 class="margin-bottom-10 margin-top-30">
                                <i class="material-icons">check_circle</i> 
                                <b>Confirmados</b>
                            </h4>

                            <div class="table-scroll" style="overflow-x: scroll;">

                                <table class="table table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 30px; width: 30px;">
                                            ID
                                        </th>
                                        <th style="min-width: 200px;">
                                            Piloto
                                        </th>
                                        <th style="min-width: 100px; width: 100px;">
                                            Combustível
                                        </th>          
<!--                                         <th style="min-width: 110px; width: 110px;">
                                            Pref. aeronave
                                        </th>  -->       
                                        <th style="min-width: 130px; width: 130px;" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                            Filial
                                        </th>                                                                                                                                             
                                        <th style="min-width: 155px; width: 155px;">
                                            Agendado para
                                        </th>                                 
                                        <th style="min-width: 90px; width: 90px;">
                                            Ações
                                        </th>                                                                        
                                    </thead>
                                    <tbody> 
<!--                                       
                                        <tr>
                                            <td data-label="ID">
                                                
                                                1
                                                </a>
                                            </td>
                                            <td data-label="Piloto">
                                                
                                                <u>Anderson Alves</u>
                                                </a>
                                            </td>
                                            <td data-label="Combustível">
                                                
                                                JET-A1
                                                </a>
                                            </td> 
                                            <td data-label="Litros">
                                                
                                                14
                                                </a>
                                            </td> 
                                            <td data-label="Pref. aeronave">
                                                
                                                PT-ZKW
                                                </a>
                                            </td>    
                                            <td data-label="Filial">
                                                
                                                Caçador SBCD                                                                                                         
                                                </a>
                                            </td>                                                                                                            
                                            <td data-label="Agendado para">
                                                
                                                10/08/2020 08:52
                                                </a>
                                            </td>
                                            <td data-label="Valor">
                                                
                                                R$ 568,67
                                                </a>
                                            </td> 
                                            <td data-label="Ações">
                                                <a class="dashboard-status-button margin-bottom-5 color-red">Cancelar</a>                                                                                      
                                            </td>
                                        </tr>   -->  
                                               
                                        <tr v-show="data.confirmados.itens.length == 0 && loaded">
                                            <td colspan="9">
                                                Nenhum resultado encontrado.
                                            </td>
                                        </tr>                                      

                                        <tr v-for="item in data.confirmados.itens" v-bind:class="{'error': item.erro == 1}">
                                            <td data-label="ID">
                                                {{item.id}}
                                                <span class="dashboard-status-button color-orange clearfix float-right hidden-lg hidden-xl hidden-md hidden-sm" v-show="item.erro == 1" style="margin-top: -12px; margin-right: 10px;">
                                                    <i class="material-icons" style="color: #fff !important;">warning</i>
                                                    <b>{{item.statusObservacao}}</b>
                                                </span>                                             
                                            </td>
                                            <td data-label="Piloto">
                                                <u>{{item.contratante.nome}}</u>
                                                <br v-if="item.cliente">
                                                <small v-if="item.cliente"><i class="material-icons">people</i> Cliente:    <strong style="font-weight: bold !important; color: #000;">{{item.cliente.razaoSocial ? item.cliente.razaoSocial : item.cliente.nome}}</strong></small>                                                 
                                                <br>
                                                <small><i class="material-icons">airplanemode_active</i> Pref. aeronave:    <strong style="font-weight: bold !important; color: #000;">{{item.auxiliar1}}</strong></small>
                                                <br>
                                                <span class="dashboard-status-button color-orange clearfix margin-top-5 hidden-xs" v-show="item.erro == 1">
                                                    <i class="material-icons" style="color: #fff !important;">warning</i>
                                                    <b>{{item.statusObservacao}}</b>
                                                </span>

                                            </td>
<!--                                             <td data-label="Pref. aeronave">
                                                {{item.auxiliar1}}
                                            </td>     -->
                                            <td data-label="Combustível">
                                                {{item.catalogo.nome}}<br>
                                                <small v-show="item.quantidade && item.quantidade != 0"><i class="material-icons">local_gas_station</i>{{item.quantidade && item.quantidade != 0 ? item.quantidade + " litros" : ''}}</small>
                                            </td> 
                                            <td data-label="Filial" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                                {{item.empresa.nome}}
                                            </td>    
                                            <td data-label="Agendado para">
                                                {{item.data | formatDate}} às {{item.horaInicio.substr(0,item.horaInicio.length -3)}}h
                                            </td>
                                            <td data-label="Ações">
                                                <router-link :to="{'name': 'EditarPedidos', 'query': {'c': item.cod}}" class="dashboard-status-button margin-bottom-5 color-green click">Concluir</router-link>
                                                <br class="hidden-xs">                                                                                      
                                                <a class="dashboard-status-button margin-bottom-5 color-red click" v-on:click="cancelar(item.cod)">Cancelar</a>
                                            </td>
                                        </tr> 

                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-xl-12" v-show="tab == 'cancelados'">                        

                            <h4 class="margin-bottom-10">
                                <i class="material-icons">close</i> 
                                <b>Cancelados</b>
                            </h4>


                            <div class="table-scroll" style="overflow-x: scroll;">

                                <table class="table table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 30px; width: 30px;">
                                            ID
                                        </th>
                                        <th style="min-width: 200px;">
                                            Detalhes
                                        </th>
                                        <th style="min-width: 100px; width: 100px;">
                                            Combustível
                                        </th>          
<!--                                         <th style="min-width: 110px; width: 110px;">
                                            Pref. aeronave
                                        </th>  -->       
                                        <th style="min-width: 130px; width: 130px;" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                            Filial
                                        </th>                                                                                                                                             
                                        <th style="min-width: 155px; width: 155px;">
                                            Agendado para
                                        </th>                                 
                                        <!-- <th style="min-width: 80px; width: 80px;">
                                            Ações
                                        </th>  -->                                                                       
                                    </thead>
                                    <tbody> 
<!--                                       
                                        <tr>
                                            <td data-label="ID">
                                                
                                                1
                                                </a>
                                            </td>
                                            <td data-label="Piloto">
                                                
                                                <u>Anderson Alves</u>
                                                </a>
                                            </td>
                                            <td data-label="Combustível">
                                                
                                                JET-A1
                                                </a>
                                            </td> 
                                            <td data-label="Litros">
                                                
                                                14
                                                </a>
                                            </td> 
                                            <td data-label="Pref. aeronave">
                                                
                                                PT-ZKW
                                                </a>
                                            </td>    
                                            <td data-label="Filial">
                                                
                                                Caçador SBCD                                                                                                         
                                                </a>
                                            </td>                                                                                                            
                                            <td data-label="Agendado para">
                                                
                                                10/08/2020 08:52
                                                </a>
                                            </td>
                                            <td data-label="Valor">
                                                
                                                R$ 568,67
                                                </a>
                                            </td> 
                                            <td data-label="Ações">
                                                <a class="dashboard-status-button margin-bottom-5 color-red">Cancelar</a>                                                                                      
                                            </td>
                                        </tr>   -->  
                                               
                                        <tr v-show="data.cancelados.itens.length == 0 && loaded">
                                            <td colspan="9">
                                                Nenhum resultado encontrado.
                                            </td>
                                        </tr>                                      

                                        <tr v-for="item in data.cancelados.itens">
                                            <td data-label="ID">
                                                {{item.id}}
                                            </td>
                                            <td data-label="Detalhes">
                                                <u>{{item.contratante.nome}}</u>
                                                <br v-if="item.cliente">
                                                <small v-if="item.cliente"><i class="material-icons">people</i> Cliente:    <strong style="font-weight: bold !important; color: #000;">{{item.cliente.razaoSocial ? item.cliente.razaoSocial : item.cliente.nome}}</strong></small>                                                                                                 
                                                <br>
                                                <small><i class="material-icons">airplanemode_active</i> Pref. aeronave:    <strong style="font-weight: bold !important; color: #000;">{{item.auxiliar1}}</strong></small>
                                                <br>
                                                <small><i class="material-icons">textsms</i> Motivo cancelamento:    <strong style="font-weight: bold !important; color: #000;">{{item.statusObservacao}}</strong></small>
                                                <br>
                                                <small><i class="material-icons">access_time</i> Cancelado em:    <strong style="font-weight: bold !important; color: #000;">{{item.atualizacao | formatDate}}</strong></small>

                                            </td>
<!--                                             <td data-label="Pref. aeronave">
                                                {{item.auxiliar1}}
                                            </td>     -->
                                            <td data-label="Combustível">
                                                {{item.catalogo.nome}}<br>
                                                <small v-show="item.quantidade && item.quantidade != 0"><i class="material-icons">local_gas_station</i>{{item.quantidade && item.quantidade != 0 ? item.quantidade + " litros" : ''}}</small>
                                            </td> 
                                            <td data-label="Filial" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                                {{item.empresa.nome}}
                                            </td>    
                                            <td data-label="Agendado para">
                                                {{item.data | formatDate}} às {{item.horaInicio.substr(0,item.horaInicio.length -3)}}h
                                            </td>
<!--                                             <td data-label="Ações">
                                                <a class="dashboard-status-button margin-bottom-5 color-red click" v-on:click="cancelar(item.cod)">Cancelar</a>
                                            </td> -->
                                        </tr> 

                                    </tbody>
                                </table>

                                <div class="pagination-container margin-top-60 margin-bottom-60">
                                    <nav class="pagination">
                                        <ul>
                                            <li class="pagination-arrow" v-show="data.cancelados.page > 1" v-on:click="form.page = (data.cancelados.page - 1); get(true);">
                                                <a>
                                                    <i class="material-icons">arrow_back</i>
                                                    Anterior
                                                </a>
                                            </li>
                                            <li class="pagination-arrow" v-show="data.cancelados.page >= 1 && data.cancelados.page < (data.cancelados.pages.length)" v-on:click="form.page = (data.cancelados.page + 1); get(true);">
                                                <a>
                                                    Próxima
                                                    <i class="material-icons">arrow_forward</i>
                                                </a>
                                            </li>    
                                            <br class="hidden-lg hidden-xl hidden-md">                                        
                                            <li v-for="(item, index) in data.cancelados.pages" v-show="item.show">
                                                <a class="" v-bind:class="{'current-page': item.index == data.cancelados.page}" v-on:click="form.page = item.index; get(true);">
                                                    {{item.index}}
                                                </a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>

                            </div>

                        </div>
                    </div>                     

                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Agendamentos',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },     
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        }
    },        
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "data":                 {
                "pendentes":        {
                    "itens":        []
                },
                "confirmados":      {
                    "itens":        []
                },
                "cancelados":       {
                    "itens":        []
                }                
            },
            "empresas":             {
                "itens":            []
            },            
            "tab":                  "agendados",
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "agendamento",
                "filtro":           "pendentes",
                "page":             1,
                "empresaCod":       ""
            }              
        }
    },
    methods: {
        setTab: function(tab) {
            var self        = this;
            console.log("setTab()", tab);
            self.tab        = tab;

            self.form.page  = 1;

            if (tab == "agendados") {
                self.form.filtro = "pendentes";
            }

            if (tab == "cancelados") {
                self.form.filtro = "cancelados";
            }            

            self.get(true);

        },        
        get: function(e) {
            var self        = this;
            console.log("get()", self.form);
            if (e) loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/pedidos.php", {params: self.form, db: "agendamentos"})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data.pendentes.itens       = [];
                    self.data.confirmados.itens     = [];
                    self.data.cancelados.itens      = [];

                    response.data.result.itens.forEach(function(item) {
                        if (item.status == 0) {
                            self.data.pendentes.itens.push(item);
                        } else if (item.status == 1) {
                            self.data.confirmados.itens.push(item);
                        } else if (item.status == -1) {
                            // self.data.cancelados.itens.push(item);
                        }
                    });

                    if (self.tab == "cancelados") {
                        self.data.cancelados    = response.data.result;   
                    }

                    self.loaded                 = true;
                    if (e) loading.hide();
                    self.$root.scrollTop();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    if (e) loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        confirmar: function(cod) {
            console.log("confirmar()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja confirmar?", function() {
                
                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "pedidoCod":    cod,
                    "acao":         "confirmar"
                };                

                self.loading.confirmar   = true;
                loading.show();
                
                axios.put("api/agendamento.php", form)
                .then(response => {
                    console.log("confirmar() response", response)
                    self.loading.confirmar    = false;
                    self.get(true);
                    alert(response.data.message);
                })
                .catch(error => {
                    console.log("confirmar() error", error)
                    loading.hide();
                    self.loading.confirmar    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        getEmpresas: function() {
            var self        = this;
            console.log("getEmpresas()");
            
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo != "admin" && self.$root.user.tipo != "prestador" && self.$root.user.tipo != "gerencial") {
                    return resolve(true);
                }

                var form = {
                    "db":               "empresas",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/empresas.php", form)
                .then(response => {
                    
                    console.log("getEmpresas() response", response);
                    self.empresas       = response.data.result;
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getEmpresas() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));                
                });   
            });   
        },         
        cancelar: function(cod) {
            console.log("cancelar()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja cancelar?", function() {
                var texto               = prompt("Qual o motivo do cancelamento?");
                if (!texto)             return false; 
                self.loading.cancelar   = true;
             
                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "pedidoCod":    cod,
                    "acao":         "cancelar",
                    "texto":        texto
                };                

                loading.show();
                
                axios.put("api/agendamento.php", form)
                .then(response => {
                    console.log("cancelar() response", response)
                    self.loading.cancelar    = false;
                    self.get(true);
                    alert(response.data.message);
                })
                .catch(error => {
                    console.log("cancelar() error", error)
                    loading.hide();
                    self.loading.cancelar    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        init: function() {
            var self = this;
            Promise.all([
                self.get(),
                self.getEmpresas()
            ]).then(function() {
                loading.hide();
            }).catch(function(error) {
                loading.hide();
            });            
        }        
    },
    created: function() {
        var self = this;
        loading.show();

        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.init();
            });
        } else {
            self.init();
        }  

         
    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Agendamentos.vue